import React from "react";
import { SearchX } from "lucide-react";
import StatusPage from "../statusPage/StatusPage";

// Thin wrapper around StatusPage so existing imports
// (`components/notFound/notFound`) keep working — the visual is now the shared
// modern status page. The bespoke 252px Montserrat treatment lived in
// notFound.scss; that file is no longer imported and can be removed in a
// follow-up cleanup commit.

const NotFound = () => (
  <StatusPage
    code="404"
    tone="muted"
    Icon={SearchX}
    title="Page not found"
    message="The page you're looking for doesn't exist or has been moved. Double-check the URL or head back to the dashboard."
  />
);

export default NotFound;
